//project imports
import cnt from "../../services/definedConstant";

const INITIAL_STATE = {
  authStatus: "loading", // loading | authenticated | anonymous
  isSignedIn: false,
  userToken: false,
  userData: false,
  configData: {},
  lockscreenData: {
    userName: null,
    profileFirstName: null,
    profileLastName: null,
  },
  authBuffer: "",
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case cnt.SIGN_IN:
      return {
        ...state,
        authStatus: "authenticated",
        isSignedIn: true,
        userToken: payload.session,
        userData: payload,
        configData: payload.configData,
      };
    case cnt.AUTH_BUFFER:
      return {
        ...state,
        authBuffer: payload,
      };
    case cnt.AUTH_STATUS:
      return {
        ...state,
        authStatus: payload,
        ...(payload === "anonymous"
          ? {
              isSignedIn: false,
              userToken: false,
              userData: false,
            }
          : {}),
      };
    case cnt.SIGN_OUT:
      return {
        ...INITIAL_STATE,
        authStatus: "anonymous",
        userToken: null,
        userData: {},
        isAuthenticated: false,
      };
    case cnt.LOCKSCREEN:
      return {
        ...state,
        authStatus: "anonymous",
        isSignedIn: false,
        userToken: false,
        userData: false,
        configData: {},
      };
    default:
      return state;
  }
};
